<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="5">
        <v-card class="pa-8 text-center">
          <template v-if="loading">
            <v-progress-circular indeterminate color="primary" size="56" class="mb-5" />
            <h2 class="text-h5">Completing sign-in…</h2>
          </template>
          <template v-else>
            <v-icon color="error" size="56" class="mb-4">mdi-alert-circle</v-icon>
            <h2 class="text-h5 mb-3">Sign-in failed</h2>
            <p class="text-medium-emphasis mb-5">{{ error }}</p>
            <v-btn color="primary" to="/login">Back to login</v-btn>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'

export default {
  name: 'OidcCallback',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const authStore = useAuthStore()
    const loading = ref(true)
    const error = ref('')

    onMounted(async () => {
      try {
        if (route.query.error) {
          throw new Error(String(route.query.error_description || route.query.error))
        }
        await authStore.completeOidcLogin({
          code: String(route.query.code || ''),
          state: String(route.query.state || '')
        })
        router.replace('/lists')
      } catch (failure) {
        error.value = failure.response?.data?.detail || failure.message || 'Keycloak login could not be completed.'
        loading.value = false
      }
    })

    return { loading, error }
  }
}
</script>
